import { useForumType } from '@/components/hooks/useForumType';
import React from "react";
import {
  fmCrosspostSiteNameSetting,
  fmCrosspostBaseUrlSetting,
} from "../../lib/instanceSettings";
import { Link } from "../../lib/reactRouterWrapper";
import { combineUrls } from "../../lib/vulcan-lib/utils";
import SingleColumnSection from "../common/SingleColumnSection";
import PostsPagePostHeader from "./PostsPage/PostsPagePostHeader";
import { Typography } from "../common/Typography";
import { StatusCodeSetter } from "../next/StatusCodeSetter";
import { defineStyles } from '@/components/hooks/defineStyles';
import { useStyles } from '@/components/hooks/useStyles';

const styles = defineStyles("ForeignCrosspostEditForm", (theme: ThemeType) => ({
  link: {
    color: theme.palette.primary.main,
  },
}));

const ForeignCrosspostEditForm = ({post}: {
  post: PostsPage,
}) => {
  const { forumType } = useForumType();
  const classes = useStyles(styles);
  const url = combineUrls(fmCrosspostBaseUrlSetting.get(forumType) ?? "", `editPost?postId=${post._id}&eventForm=false`);

  const postWithNavigation: PostsWithNavigation = {
    ...post,
    podcastEpisode: null,
    tableOfContents: null,
    sequence: null,
    prevPost: null,
    nextPost: null,
    reviewWinner: null,
    glossary: [],
  };

  return (<>
    <StatusCodeSetter status={200}/>
    <SingleColumnSection>
      <PostsPagePostHeader post={postWithNavigation} hideMenu hideTags />
      <Typography variant="body2" gutterBottom>
        This post cannot be edited as it is a crosspost.{' '}
        <a href={url} className={classes.link}>Click here</a> to edit on{' '}
        {fmCrosspostSiteNameSetting.get(forumType)}.
      </Typography>
      {post.draft && <Typography variant="body2">
        This crosspost is a draft. Crosspost drafts cannot be undrafted. You
        will need to{' '}
        <Link to='/contact' className={classes.link}>
          contact a site admin
        </Link>{' '}
        for help. Sorry about that!
      </Typography>}
    </SingleColumnSection>
  </>);
}

export default ForeignCrosspostEditForm;


